import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import CustomCheckbox from '../../../../../components/shared/CustomCheckbox/CustomCheckbox';
import { TableType } from '../../../../../model/rolesAndPerms.model';
import zeplinColor from '../../../../../theme/Color';
import { CheckedIcon, Icon, IndeterminateIcon } from '../../../../../utilities/rolesAndPermsUtils';

export const PermissionTable = ({
  table,
  onChange,
}: {
  table: TableType;
  onChange?: (updated: TableType) => void;
}) => {
  const [data, setData] = useState<TableType>(table);

  useEffect(() => {
    setData(table);
  }, [table]);

  const update = (next: TableType) => {
    setData(next);
    onChange?.(next);
  };

  const handleHeaderChange = (colIndex: number) => {
    const newColumns = JSON.parse(JSON.stringify(data.columns));
    const newRows = JSON.parse(JSON.stringify(data.rows));
    const newValue = !newColumns[colIndex].value;

    newColumns[colIndex].value = newValue;
    newColumns[colIndex].indeterminate = false;

    if (colIndex === 0) {
      // Full Access toggle
      newColumns.forEach((col: any) => {
        col.value = newValue;
        col.indeterminate = false;
      });
      newRows.forEach((row: any) => {
        row.values = [newValue, newValue, newValue, newValue];
      });
    } else {
      // Individual column toggle (View, Create, etc)
      const valIndex = colIndex - 1;
      newRows.forEach((row: any) => {
        row.values[valIndex] = newValue;
      });
    }
    update({ ...data, columns: newColumns, rows: newRows });
  };

  const handleRowCellChange = (rowIndex: number, valIndex: number) => {
    const newRows = JSON.parse(JSON.stringify(data.rows));
    const newColumns = JSON.parse(JSON.stringify(data.columns));

    newRows[rowIndex].values[valIndex] = !newRows[rowIndex].values[valIndex];

    // Update Column Header State (All/Indeterminate)
    const colIndex = valIndex + 1;
    const allChecked = newRows.every((r: TableType['rows'][number]) => r.values[valIndex]);
    const someChecked = newRows.some((r: TableType['rows'][number]) => r.values[valIndex]);

    newColumns[colIndex].value = allChecked;
    newColumns[colIndex].indeterminate = someChecked && !allChecked;

    // Update "Full Access" Header
    newColumns[0].value = newRows.every((r: TableType['rows'][number]) =>
      r.values.every((v: boolean) => v),
    );

    update({ ...data, rows: newRows, columns: newColumns });
  };
  console.log(table, 'table');
  return (
    <Box>
      <Paper sx={{ width: '100%', border: 'none', boxShadow: 'none', margin: ' 20px 0' }}>
        <TableContainer>
          <Table stickyHeader aria-label='sticky table'>
            <TableHead>
              <TableRow
                sx={{
                  border: '1px solid black',
                  borderRadius: '14px',
                  '& th': {
                    backgroundColor: '#f5f5f5',
                  },
                  '& th:first-child': {
                    borderRadius: '14px 0px 0px 14px',
                  },
                  '& th:last-child': {
                    borderRadius: '0px 14px 14px 0px',
                  },
                }}
              >
                {data.columns.map(({ name, value, indeterminate }, index) => {
                  const isFirstColumnName = index === 0;

                  return (
                    <TableCell key={name} width={isFirstColumnName ? '36%' : undefined}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                      >
                        {isFirstColumnName && <Typography variant='body3'>{name}</Typography>}
                        <CustomCheckbox
                          label={
                            <Typography variant='body3' sx={{ color: zeplinColor.BasicBlack }}>
                              {isFirstColumnName ? 'Full Access' : name}
                            </Typography>
                          }
                          icon={<Icon />}
                          disableFocusRipple
                          checkedIcon={<CheckedIcon />}
                          indeterminate={index ? indeterminate : false}
                          indeterminateIcon={<IndeterminateIcon />}
                          checked={value}
                          onChange={() => handleHeaderChange(index)}
                        />
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.rows.map((row, rowIndex) => {
                return (
                  <TableRow
                    hover
                    role='checkbox'
                    tabIndex={-1}
                    key={rowIndex}
                    sx={{
                      '&:last-child td, &:last-child th': { borderBottom: '2px solid #ddd' },
                      textDecoration: 'none',
                      color: 'inherit',
                    }}
                  >
                    {data.columns.map((col, colIndex) => {
                      if (colIndex === 0) {
                        return (
                          <TableCell key={col.name}>
                            <Typography variant='body3'>{row.name}</Typography>
                          </TableCell>
                        );
                      }

                      const valIndex = colIndex - 1;

                      return (
                        <TableCell key={col.name}>
                          <CustomCheckbox
                            label={''}
                            checked={row.values[valIndex]}
                            icon={<Icon />}
                            disableFocusRipple
                            checkedIcon={<CheckedIcon />}
                            onChange={() => handleRowCellChange(rowIndex, valIndex)}
                          />
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};
